import React, { useEffect } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import FilterLayoutItem from '@/components/_common/Filters/FilterLayoutsModal/FilterLayoutItem';
import { useToast } from '@/components/_common/Toast';
import { FilterLayoutsFilter } from '@/redux/slices/slice_types';

interface Props {
  item: FilterLayoutsFilter;
  columnName: 'show' | 'hide';
  index: number;
  isOnlyChild: boolean;
  togglePin: (columnName: 'show' | 'hide', id: string) => void;
}

export type FilterLayoutItemDraggableData = Pick<Props, 'index' | 'columnName' | 'item'>;

const FilterLayoutItemDraggable: React.FC<Props> = ({ item, columnName, index, isOnlyChild, togglePin }) => {
  const data: FilterLayoutItemDraggableData = { index, item, columnName };
  const forbidRelocating = isOnlyChild && columnName === 'show';
  const { info } = useToast();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    animateLayoutChanges: (e) => {
      return e.isDragging || e.isSorting;
    },
    transition: {
      duration: 250,
      easing: 'ease-in-out'
    },
    id: item.id,
    data
  });

  useEffect(() => {
    if (isDragging && isOnlyChild && forbidRelocating) {
      info('Can not hide the only visible filter');
    }
  }, [isOnlyChild, forbidRelocating, isDragging]);

  const style = {
    cursor: 'grab',
    opacity: !isDragging || forbidRelocating ? 1 : 0.5,
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div ref={forbidRelocating ? undefined : setNodeRef} style={style} {...attributes} {...listeners}>
      <FilterLayoutItem item={item} togglePin={togglePin} />
    </div>
  );
};

export default FilterLayoutItemDraggable;
